const BASE_WIDTH = 1080;
const BASE_HEIGHT = 1920;

const MIN_HEIGHT = 1780;
const MAX_HEIGHT = 2260;
const MIN_MAP_TOP_OFFSET = -60;
const MAX_MAP_TOP_OFFSET = 100;

function _calculate_container_height() {
	const viewport_width = window.innerWidth;
	const viewport_height = window.innerHeight;
	
	const width_scale = viewport_width / BASE_WIDTH;
	const ideal_container_height = viewport_height / width_scale;
	
	return Math.max(MIN_HEIGHT, Math.min(MAX_HEIGHT, ideal_container_height));
}

function _calculate_scale(container_height) {
	const viewport_width = window.innerWidth;
	const viewport_height = window.innerHeight;
	
	const width_scale = viewport_width / BASE_WIDTH;
	const height_scale = viewport_height / container_height;
	
	return Math.min(width_scale, height_scale);
}

function _calculate_map_top_offset(container_height) {
	if (container_height <= MIN_HEIGHT)
		return MIN_MAP_TOP_OFFSET;
	
	if (container_height >= MAX_HEIGHT)
		return MAX_MAP_TOP_OFFSET;
	
	if (container_height === BASE_HEIGHT)
		return 0;
	
	if (container_height < BASE_HEIGHT) {
		const ratio = (container_height - MIN_HEIGHT) / (BASE_HEIGHT - MIN_HEIGHT);
		return MIN_MAP_TOP_OFFSET + ratio * (0 - MIN_MAP_TOP_OFFSET);
	}
	
	const ratio = (container_height - BASE_HEIGHT) / (MAX_HEIGHT - BASE_HEIGHT);
	return 0 + ratio * (MAX_MAP_TOP_OFFSET - 0);
}

function _apply_responsive() {
	const container = document.getElementById('container');
	
	if (!container) return;
	
	const container_height = _calculate_container_height();
	container.style.height = `${container_height}px`;
	
	const scale = _calculate_scale(container_height);
	container.style.transform = `scale(${scale})`;
	
	const top_offset = _calculate_map_top_offset(container_height);
	const maps = container.querySelector('.maps');
	const pins = container.querySelector('.pins');
	
	if (maps)
		maps.style.top = `${top_offset}px`;
	
	if (pins)
		pins.style.top = `${top_offset}px`;
}

function init() {
	const apply_when_ready = () => {
		setTimeout(_apply_responsive, 0);
	};
	
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', apply_when_ready);
	} else {
		apply_when_ready();
	}
	
	window.addEventListener('resize', _apply_responsive);
	window.addEventListener('orientationchange', () => {
		setTimeout(_apply_responsive, 100);
	});
	
	const container = document.getElementById('container');
	if (container) {
		const observer = new MutationObserver(() => {
			_apply_responsive();
		});
		observer.observe(container, { childList: true, subtree: true });
	}
}

export default { init };

